import { useState, useEffect } from "react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-md border-b border-stone-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNav("#home"); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://www.archiconservices.com/img/logo.jpg"
            alt="Archicon Services Logo"
            className="w-10 h-10 rounded object-cover"
          />
          <div className="flex flex-col leading-tight">
            <span
              className={`font-semibold text-sm tracking-widest uppercase transition-colors duration-300 ${
                scrolled ? "text-stone-900" : "text-white"
              }`}
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Archicon
            </span>
            <span
              className={`text-xs tracking-widest uppercase transition-colors duration-300 ${
                scrolled ? "text-stone-500" : "text-white/70"
              }`}
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Services
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                className={`text-xs tracking-widest uppercase font-medium transition-colors duration-300 cursor-pointer hover:opacity-70 ${
                  scrolled ? "text-stone-700" : "text-white/90"
                }`}
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:+17139276666"
            className={`text-xs tracking-widest uppercase font-medium transition-colors duration-300 cursor-pointer hover:opacity-70 whitespace-nowrap ${
              scrolled ? "text-stone-700" : "text-white/90"
            }`}
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <i className="ri-phone-line mr-1"></i> (713) 927-6666
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav("#contact"); }}
            className="bg-stone-900 text-white text-xs tracking-widest uppercase px-5 py-2.5 rounded-sm hover:bg-stone-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Consultation
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
            scrolled ? "text-stone-900" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className="text-xs tracking-widest uppercase font-medium text-stone-700 cursor-pointer hover:text-stone-900"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+17139276666"
            className="text-xs tracking-widest uppercase font-medium text-stone-700 cursor-pointer"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <i className="ri-phone-line mr-1"></i> (713) 927-6666
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav("#contact"); }}
            className="bg-stone-900 text-white text-xs tracking-widest uppercase px-5 py-3 rounded-sm text-center cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Start Consultation
          </a>
        </div>
      )}
    </nav>
  );
}
